import { type AxiosInstance } from "axios";
import useAxiosAuth from "../hooks/useAxiosAuth.ts";
import { useQuery } from "@tanstack/react-query";

const transformSiteGeometryData = (response: any) => {
  return response.data;
};

export const extractSiteGeometryId = (
  geometryUrlOrId?: string | number | null
) => {
  if (geometryUrlOrId == null || geometryUrlOrId === "") return undefined;
  const asString = String(geometryUrlOrId);
  return asString.match(/\/site_geometry\/(\d+)\//)?.[1] ?? asString;
};

export const siteGeometryQueryKey = (
  geometryUrlOrId?: string | number | null
) => ["site_geometry", extractSiteGeometryId(geometryUrlOrId)] as const;

export const fetchSiteGeometry = async (
  axiosAuth: AxiosInstance,
  geometryUrlOrId: string | number
) => {
  const geometryId = extractSiteGeometryId(geometryUrlOrId);
  if (!geometryId) {
    throw new Error("Invalid geometry id");
  }
  const response = await axiosAuth.get(
    `${process.env.REACT_APP_API_BASE_URL}site_geometry/${geometryId}/`
  );
  return response;
};

export function useSiteGeometry(
  session: any,
  geometryUrl?: string,
  enabled = true
) {
  const axiosAuth = useAxiosAuth();
  const geometryId = extractSiteGeometryId(geometryUrl);

  return useQuery({
    queryKey: siteGeometryQueryKey(geometryUrl),
    queryFn: async () => await fetchSiteGeometry(axiosAuth, geometryId!),
    select: (data) => transformSiteGeometryData(data),
    enabled: enabled && !!session?.user && !!geometryId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
